import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteModelDetail = createAsyncThunk(
  'listModels/fetchDeleteModel',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteModelDetail(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteModelDetailSlice = createSlice({
  name: 'modeldetails/delete',
  initialState,
  reducers: {
    resetDeleteModelDetail: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteModelDetail.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteModelDetail.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteModelDetail.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteModelDetailSlice.reducer
export const { resetDeleteModelDetail } = deleteModelDetailSlice.actions
